"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelPreviousify = void 0;
const canceled_promise_1 = require("./canceled-promise");
function cancelPreviousify(originalMethod) {
    let rej;
    return function (...args) {
        if (rej) {
            rej(new canceled_promise_1.CanceledPromise());
        }
        return new Promise((resolve, reject) => {
            rej = reject;
            originalMethod.apply(this, args)
                .then((data) => resolve(data))
                .catch((err) => reject(err));
        });
    };
}
exports.cancelPreviousify = cancelPreviousify;
